import {RepositoryNotLoading} from "./Repository";

const resource = 'v2/vehicle-categories';

export default {
    list() {
        return RepositoryNotLoading.get(`${resource}`);
    }
}
